import './forgot-password-token-expired.style.sass';
import template from './forgot-password-token-expired.tpl.pug';

export default {
    selector: 'dbAForgotPasswordTokenExpired',
    template: template(),
};



// WEBPACK FOOTER //
// ./src/application/scene/identity/scene/forgot-password/scene/forgot-password-token-expired/forgot-password-token-expired.cmpt.js